export const MainURL = "https://tripbemyguest.com";

export const AdminURL = "https://tripinside.co.kr";